import React from 'react';
import { Box, Inscription, Text } from '@common-fe/common-fe';

import { HorizontalLine } from '@/components';

import { ScheduleYear } from './payrollCalendarSection.types';

interface Props {
  yearGroup: ScheduleYear;
  isLast?: boolean;
  testId?: string;
}

const PayrollCalendarScheduleItem: React.FC<Props> = ({ yearGroup, isLast, testId }) => (
  <Box data-testid={`${testId}_year-${yearGroup.year}`}>
    <Inscription weight="bold" size="14px" lineHeight="20px" color="textBody">
      {yearGroup.year}
    </Inscription>

    <Box
      margin={{ top: 'spacing8' }}
      style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}
    >
      {yearGroup.months.map((month) => (
        <Box key={month.monthLabel} data-testid={`${testId}_month-${month.monthLabel}`}>
          <Text weight={700} color="textBody">
            {month.monthLabel}{' '}
            <Text as="span" weight={400} color="textDisabled">
              ({month.count})
            </Text>
          </Text>
          {month.dates.map((entry, idx) => (
            <Text key={idx} color="textBody" margin={{ top: 'spacing2' }}>
              {entry.formatted} ({entry.dayOfWeek})
            </Text>
          ))}
        </Box>
      ))}
    </Box>
    {!isLast && <HorizontalLine margin={{ vertical: 'spacing12' }} />}
  </Box>
);

export default PayrollCalendarScheduleItem;
